import InboxListPage from './list'
import InboxAddPage from './add'
import InboxViewPage from './view'

export default {
  InboxListPage,
  InboxViewPage,
  InboxAddPage
}
